module.exports = __webpack_public_path__ + "img/visa.fc22ec66.svg";